import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createElement } from 'react';

/**
 * The landing page the `frontstage-cli` loopback sign-in opens in the browser.
 *
 * It is reached from the CLI only, so no `title`, `icon` or `routeRef` is
 * declared - the app derives nav items from pages that expose a route ref and
 * an icon, and this page has no business in the sidebar. The page brings its
 * own `Page`/`Header`, so the framework chrome is switched off.
 *
 * Exported for testing; the app installs it through {@link cliAuthModule}.
 */
export const cliAuthPage = PageBlueprint.make({
  name: 'cli-auth',
  params: {
    path: '/cli-auth',
    noHeader: true,
    loader: async () => {
      const { CliAuthPage } = await import('./CliAuthPage');
      return createElement(CliAuthPage);
    },
  },
});

export const cliAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [cliAuthPage],
});
